<span *ngIf="showTechError" i18n>
   If the problem persists contact <a href={{supportURL}} target="_blank">technical support</a>.
</span>
